import type { ScanServiceType, UnisonProjectTypeId } from '@witmetrics/utils';
import { useId } from '@/hooks/useId';
import NewCaseProvider from '@/providers/NewCaseProvider';
import NewCaseDialog from '@/dialogs/NewCaseDialog';
import CaseTypeBlock from './CaseTypeBlock';
import { CASE_TYPES } from './constants';
import { classes, styles } from './utils';

export type CaseCreationCardProps = {
  condensed?: boolean;
  header?: boolean;
  onClose?: () => void;
};

export default function CaseCreationCard({
  condensed,
  header = true,
  onClose,
}: CaseCreationCardProps) {
  const [caseTypeId, setCaseTypeId, { clear: clearCaseTypeId }] =
    useId<UnisonProjectTypeId>();
  const [serviceTypeId, setServiceTypeId, { clear: clearServiceTypeId }] =
    useId<ScanServiceType>();

  const startNewCase = (
    caseType: UnisonProjectTypeId,
    serviceType?: ScanServiceType
  ) => {
    setCaseTypeId(caseType);
    setServiceTypeId(serviceType);
  };

  const closeNewCase = () => {
    clearCaseTypeId();
    clearServiceTypeId();
    onClose?.();
  };

  const renderBlocks = () => {
    return (
      <div
        style={condensed ? {} : styles.wrapper}
        className={condensed ? classes.condensedWrapper : classes.wrapper}>
        {CASE_TYPES.map(
          ({ projectTypeId, serviceTypeId, title, description, src }) => (
            <CaseTypeBlock
              key={projectTypeId}
              condensed={condensed}
              projectTypeId={projectTypeId}
              description={description}
              src={src}
              title={title}
              onSelect={() => startNewCase(projectTypeId, serviceTypeId)}
            />
          )
        )}
      </div>
    );
  };

  return (
    <>
      {caseTypeId && (
        <NewCaseProvider projectTypeId={caseTypeId} serviceType={serviceTypeId}>
          <NewCaseDialog onClose={closeNewCase} />
        </NewCaseProvider>
      )}
      {header ? (
        <>
          <div className={classes.header}>
            <h2 className={classes.title}>Create a case</h2>
            <span className={classes.subtitle}>
              Select a case type to get started
            </span>
          </div>
          {renderBlocks()}
        </>
      ) : (
        renderBlocks()
      )}
    </>
  );
}
